import TweenMax, { Power2 } from "gsap/TweenMax";

class Side{
    constructor(container){
        this.container = container;
        this.busy = false;
        this.opened = false;

        this.init();
    }

    init(){
        const cmp = this;

        const videos = cmp.container.getElementsByClassName('j-side-video');
        for(let i=0; i<videos.length; i++){
            if(!videos[i].classList.contains('_vidinit')){
                new InitPxVideo({
                    "videoId": videos[i].getAttribute('id'),
                    "captionsOnDefault": true,
                    "seekInterval": 20,
                    "videoTitle": "",
                    "debug": false
                });
                videos[i].classList.add('_vidinit');
                videos[i].getElementsByTagName('video')[0].onended = () => {
                    videos[i].getElementsByTagName('video')[0].currentTime = 0;
                    videos[i].getElementsByTagName('video')[0].pause();
                    if(videos[i].getElementsByClassName('px-video-play').length > 0){                                
                        videos[i].getElementsByClassName('px-video-play')[0].classList.remove('hide');
                        videos[i].getElementsByClassName('px-video-pause')[0].classList.add('hide');
                    }
                }
            }
        }

        document.addEventListener('side.open', function(e){
            if(document.body.classList.contains('_sided')){
                cmp.busy = true;
                const lastCurrent = document.getElementsByClassName('_current-side')[0];
                const current = document.getElementById(e.detail.current);
                const videos = cmp.container.getElementsByClassName('j-side-video');
                for(let i=0; i<videos.length; i++){
                    videos[i].getElementsByTagName('video')[0].pause();
                    if(videos[i].getElementsByClassName('px-video-play').length > 0){                                
                        videos[i].getElementsByClassName('px-video-play')[0].classList.remove('hide');
                        videos[i].getElementsByClassName('px-video-pause')[0].classList.add('hide');
                    }
                }
                TweenMax.fromTo(
                    `._current-side`,
                    0.5,
                    {
                        opacity: 1
                    },
                    {
                        ease: Power2.easeOut,
                        opacity: 0,
                        onComplete: () => {
                            lastCurrent.classList.remove('_current-side');
                            lastCurrent.classList.remove('_animation-in');
                            lastCurrent.removeAttribute('style');
                            cmp.container.scrollTop = 0;
                            for(let i=0; i<videos.length; i++){
                                videos[i].getElementsByTagName('video')[0].currentTime = 0;
                            }
                            current.classList.add('_current-side');
                            setTimeout(() => {
                                current.classList.add('_animation-in');
                                cmp.opened = true;
                                cmp.container.classList.add('_opened');
                                cmp.busy = false;
                            }, 100);
                        }
                    }
                );
            }
            else{
                cmp.busy = true;
                document.body.classList.add('_sided');
                const current = document.getElementById(e.detail.current);
                current.classList.add('_current-side');
                let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
                TweenMax.fromTo(
                    `.j-pages`,
                    0.5,
                    {
                        right: 0
                    },
                    {
                        ease: Power2.easeOut,
                        right: w>768?'44vw':'100vw'
                    }
                );
                TweenMax.fromTo(
                    `.j-side`,
                    0.5,
                    {
                        right: w>768?'-44vw':'-100vw'
                    },
                    {
                        ease: Power2.easeOut,
                        right: '0',
                        onComplete: () => {
                            current.classList.add('_animation-in');
                            cmp.opened = true;
                            cmp.container.classList.add('_opened');
                            cmp.busy = false;
                        }
                    }
                );
            }
        });

        document.addEventListener('side.close', function(e){
            if(cmp.opened){
                cmp.busy = true;
                const current = document.getElementsByClassName('_current-side')[0];
                current.classList.add('_animation-out');
                const videos = cmp.container.getElementsByClassName('j-side-video');
                for(let i=0; i<videos.length; i++){
                    videos[i].getElementsByTagName('video')[0].pause();
                    if(videos[i].getElementsByClassName('px-video-play').length > 0){                                
                        videos[i].getElementsByClassName('px-video-play')[0].classList.remove('hide');
                        videos[i].getElementsByClassName('px-video-pause')[0].classList.add('hide');
                    }
                }
                let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
                TweenMax.fromTo(
                    `.j-pages`,
                    0.5,
                    {
                        right: w>768?'44vw':'100vw'
                    },
                    {
                        ease: Power2.easeOut,
                        right: '0'
                    }
                );
                TweenMax.fromTo(
                    `.j-side`,
                    0.5,
                    {
                        right: '0'
                    },
                    {
                        ease: Power2.easeOut,
                        right: w>768?'-44vw':'-100vw',
                        onComplete: () => {
                            const sidePages = document.getElementsByClassName('j-side-page');
                            for(let i=0; i<sidePages.length; i++){
                                sidePages[i].classList.remove('_current-side');
                                sidePages[i].classList.remove('_animation-in');
                                sidePages[i].classList.remove('_animation-out');
                                sidePages[i].removeAttribute('style');
                                document.body.classList.remove('_sided');
                                cmp.container.scrollTop = 0;
                                for(let i=0; i<videos.length; i++){
                                    videos[i].getElementsByTagName('video')[0].currentTime = 0;
                                }
                            }

                            cmp.opened = false;
                            cmp.container.classList.remove('_opened');
                            cmp.busy = false;
                        }
                    }
                );
            }
        });
    }
}

export default Side;